import TemplateView from '../../../TemplateView'
import InputField from '../../../components/InputField'
import NumberFormatter from '../../../number_formatter'
import { LeaveBalanceUnits } from '../../../constants'

export default class MinimumValueInput extends TemplateView {
    constructor({
        additionalClass,
        value,
        maxLength,
        disabled,
        onChange = (value) => {},
    }) {
        super()

        this.params = {
            additionalClass,
            maxLength,
            disabled,
            onChange,
        }

        this.state = {
            value,
            defaultWorkDayDuration: 8,
            units: LeaveBalanceUnits.DAYS,
        }

        this.onStatePropertyChanged('disabled', disabled => this.valueInput.setState({ disabled }))
        this.onStatePropertyChanged('units', (units) => {
            let value = parseFloat(this.state.value) || 0

            if (units === LeaveBalanceUnits.HOURS)
                value = this._recalculateValueFromDaysToHours(value)

            this._setInnerInputValue(value, units)
            this.$units.text(units === LeaveBalanceUnits.DAYS ? 'd' : 'h')
        })
    }

    templateHtml() {
        return `
            <div class='settingsNumberInput visible <%=additionalClass%>'>
                <div class='valueInputContainer'/>
                <div class='units'></div>
            </div>
            `
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
        }
    }

    afterRender() {
        this.$valueInputContainer = this.find('.valueInputContainer')

        this.formatter = new NumberFormatter(
            window.SystemSettings.decimalSeparator,
            window.SystemSettings.digitGroupingSymbol,
            2,
            true
        );

        this.valueInput = new InputField({
            onBlur: (value) => {
                value = this.formatter.normalize(value + "")
                const valueInDays = this.state.units === LeaveBalanceUnits.HOURS
                    ? this._recalculateValueFromHoursToDays(value)
                    : value

                if (valueInDays === this.state.value) return

                this.params.onChange(valueInDays)
                this._setInnerInputValue(value)
            },
            onKeyPress: (event) => {
                // always allow special keys such as arrows, backspace, etc. (fired under FireFox & Opera only)
                if (event.which < 32)
                    return;

                // FireFox, Opera & Safari fire this event even when using modifier keys.
                // In this case we must not prevent the default behavior.
                if (event.ctrlKey || event.altKey || event.metaKey)
                    return;

                // apply filter
                if (!this.charFilter(event.which))
                    event.preventDefault();
            },
            additionalClass: 'valueInput',
            maxLength: this.params.maxLength,
            value: this.state.value
        }).init(this.$valueInputContainer)

        this.$units = this.$el.find('.units')
    }

    _recalculateValueFromHoursToDays = function(value) {
        return value / this.state.defaultWorkDayDuration
    }

    _recalculateValueFromDaysToHours = function(value) {
        return value * this.state.defaultWorkDayDuration
    }

    _setInnerInputValue = function(value) {
        const normalizedValue = this.formatter.normalize( value + "")
        const formattedValue = this.formatter.format(Number(normalizedValue))
        this.valueInput.setState({ value: formattedValue })
    }

    charFilter(charCode) {
        var sym = String.fromCharCode( charCode );

        return sym >= '0' && sym <= '9'
            || sym == '-'
            || sym == '.'
            || sym == ','
            || sym == window.SystemSettings.decimalSeparator
            || sym == window.SystemSettings.digitGroupingSymbol;
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/lowBalanceSettings/components/MinimumValueInput.js